export const editOptions = (isAuthorizedToEdit: boolean) => {
    return {
        poly: {
            allowIntersection: false,
        },
        edit: isAuthorizedToEdit,
        editControlRef: {},
    };
};
